import { useEffect } from "react";

import { INotifyEnum, notify } from "@/utils/toaster";
import { storage } from "@/utils/Storage";
import { getCartListApi } from "@/utils/apis/patient/tests";

import { setSelectedCartDetails } from "@/store/slices/patient/tests";
import { useAppDispatch } from "@/store/hooks";

import { ISessionKeys } from "@/models";
import { IRoleType } from "@/models/role";

const useGetCartDetails = () => {
  const token = storage.getSessionToken(ISessionKeys.TOKEN);
  const roleType = storage.getSessionToken(ISessionKeys.ROLE_TYPE);

  const dispatch = useAppDispatch();

  const getCartDetails = async () => {
    if (roleType === IRoleType.GUEST) return;
    const cartDetailRes = await getCartListApi();
    if ("result" in cartDetailRes) {
      dispatch(setSelectedCartDetails(cartDetailRes.result));
      return;
    }
    notify(INotifyEnum.ERROR, cartDetailRes.message);
  };

  useEffect(() => {
    if (token && roleType !== IRoleType.GUEST) {
      getCartDetails();
    }
  }, [token]);

  return { getCartDetails };
};

export default useGetCartDetails;
